// theme.js
import { createTheme } from '@mui/material/styles';
const theme = (settings, mode, lang = 'ar') => {
    const direction = lang === 'ar' ? 'rtl' : 'ltr';
    const color = settings || "#3C1FAB";

    const baseTheme = {
        direction,
        typography: {
            fontFamily: 'URW DIN Arabic Demi',
            fontWeightRegular: 400,
            fontWeightMedium: 500,
            fontWeightLight: 300,
            fontWeightBold: 700,
            fontWeight: 600,
            h1: {
                fontFamily: 'URW DIN Arabic Demi', // كل h1 يظهر بـ Demi
                fontWeight: 600,                   // لأنه عرّفته بوزن 400
            },
            h2: {
                fontFamily: 'URW DIN Arabic', // Medium مثلاً
                fontWeight: 600,
            },
            h3: {
                fontFamily: 'URW DIN Arabic Cond', // Cond Medium أو أي قيمة
                fontWeight: 600,
            },
            h4: {
                 fontFamily: 'URW DIN Arabic Cond', // Cond Medium أو أي قيمة
                fontWeight: 600,
            },
            h5: {
                 fontFamily: 'URW DIN Arabic Cond', // Cond Medium أو أي قيمة
                fontWeight: 300,
            },
            h6: {
                 fontFamily: 'URW DIN Arabic Cond', // Cond Medium أو أي قيمة
                fontWeight: 300,
            },
        },
    };

    const lightPalette = {
        mode: 'light',
        primary: {
            main: color,
            text: "#fff",
            default: "#202020"
        },
        secondary: {
            main: "#00B8D7",
            text: color,
            default: "#727272"
        },
        nav: {
            main: "#FFFFFF",
            link: '#727272',
            hover: color,
            btn: color
        },
        footer: {
            main: "#102251",
            link: '#fff',
            hover: '#A69F9F'
        },
        background: {
            default: "#F8F8FA",
            // default: "#f5f8ff",
            section: "#f7f7f7",
            gray: '#727272',
            card: '#F8F8FA',
            date: '#fff',
            tap: '#e5e5e5',
            cat: '#989898',
            input: "#fff",
            form: "#fff",
            file: "#f0f0f0",
            drawer: ''
        },
        boxShadow: "0px 2px 5px 0px #0000001A",
        redColor: '#E00D00',
        yellowColor: '#FFD600',
        greenColor: '#22AB1F'
    };

    const darkPalette = {
        mode: 'dark',
        primary: {
            main: "#000",
            text: "#fff",
            default: "#fff"
        },
        secondary: {
            main: "#2e2e2e",
            text: "#fff",
            default: "#fff"
        },
        nav: {
            main: "#000",
            link: '#fff',
            hover: '#A69F9F',
            btn: color
        },
        footer: {
            main: "#121212",
            link: '#fff',
            hover: '#A69F9F'
        },
        background: {
            default: "#121212",
            gray: "#2e2e2e",
            section: "#1e1e1e",
            card: '#2e2e2e',
            date: '#2e2e2e',
            tap: '#2e2e2e',
            cat: '#2e2e2e',
            input: "#1e1e1e",
            form: "#121212",
            file: "#2e2e2e",
        },
        boxShadow: "0px 2px 5px 0px #0000001A",
        redColor: '#E00D00',
        yellowColor: '#FFD600',
        greenColor: '#22AB1F'
    };

    return createTheme({
        palette: mode === 'dark' ? darkPalette : lightPalette,
        ...baseTheme
    });
}
export default theme;